export default __webpack_public_path__ + "static/media/MicrosoftTeams-image-(6)-375X550.3e3bcdde.png";